import { createContext, useContext } from 'react'
import type { RuntimeConfig } from './runtimeConfig'

export const RuntimeConfigContext = createContext<RuntimeConfig | null>(null)

export const useRuntimeConfigContext = () => {
    const runtimeContext = useContext(RuntimeConfigContext)

    if (!runtimeContext) {
        throw new Error('RuntimeConfigContext not available')
    }

    return runtimeContext
}
